export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/vr_360_video.74cc81b.svg";